import { render, staticRenderFns } from "./FerryPickupList.vue?vue&type=template&id=885b213c"
import script from "../../controllers/ferry_pickup/ferry-pickup-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/ferry_pickup/ferry-pickup-list.js?vue&type=script&lang=js&external"
import style0 from "./FerryPickupList.vue?vue&type=style&index=0&id=885b213c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports